/**
 * @generated SignedSource<<12f1c42b4ae23af42ec94ee38ee67226>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdvertisementForm_TreeNodeFragment$data = {
  readonly id: string;
  readonly structureDefinition: {
    readonly extension?: {
      readonly advertisementConfig?: {
        readonly isFeatured: boolean;
      } | null | undefined;
    };
  };
  readonly " $fragmentType": "AdvertisementForm_TreeNodeFragment";
};
export type AdvertisementForm_TreeNodeFragment$key = {
  readonly " $data"?: AdvertisementForm_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AdvertisementForm_TreeNodeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdvertisementForm_TreeNodeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "structureDefinition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "extension",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AdvertisementConfiguration",
                      "kind": "LinkedField",
                      "name": "advertisementConfig",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isFeatured",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "RootExtensionImpl",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "RootStructureDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};

(node as any).hash = "0c02b8f99c40b41a80087dc64780171b";

export default node;
